/**
 * Card field-assertion whitelist (docs/02 §4 / docs/01 check_card_field_evidence).
 * Same thirteen names the SQL trigger and contract-lint enforce.
 */

export const CARD_ASSERTION_WHITELIST = [
  'annual_fee_cents',
  'closed_loop_merchant',
  'due_days_after_close',
  'foreign_txn_fee_bps',
  'grace_exists',
  'grace_restore',
  'monthly_fee_cents',
  'network',
  'network_tier',
  'product_name',
  'purchase_apr_bps',
  'statement_day_of_month',
  'status',
] as const;

export type CardAssertionField = (typeof CARD_ASSERTION_WHITELIST)[number];

export function isCardAssertionField(name: string): name is CardAssertionField {
  return (CARD_ASSERTION_WHITELIST as readonly string[]).includes(name);
}
